// https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
export function shuffle<T>(array: T[]): T[] {
  if (!array) {
    return [];
  }

  let currentIndex = array.length,
    randomIndex: number;

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }

  return array;
}

export function toggleItemInArray<T>(array: T[], item: T) {
  if (array.includes(item)) {
    return array.filter((i) => i !== item);
  } else {
    return [...array, item];
  }
}

export function arrayIncludes<T>(array: readonly T[], item: any): item is T {
  return array.includes(item);
}

export function asArray<T>(value: T | T[] | null | undefined) {
  value ??= [];
  return Array.isArray(value) ? value : [value];
}

export function arrayIsEqual<T>(a: T[], b: T[]) {
  if (a === b) {
    return true;
  }
  if (a.length !== b.length) {
    return false;
  }

  return a.every((item) => b.includes(item));
}
